import { render, staticRenderFns } from "./UsuarioCompradorGrid.vue?vue&type=template&id=7bd08190&scoped=true&"
import script from "./UsuarioCompradorGrid.vue?vue&type=script&lang=js&"
export * from "./UsuarioCompradorGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd08190",
  null
  
)

/* custom blocks */
import block0 from "./UsuarioCompradorGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports